module.exports = __webpack_public_path__ + "img/signup-guide-01-03.8cdd420b.png";